import { Pipe, PipeTransform } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { Account, TPTariffsMap } from '@personal-area/global/accounts/models';
import { Role } from '@personal-area/global/users/models';

@Pipe({
  name: 'accountTariff',
  pure: false,
  standalone: true,
})
export class AccountTariffPipe implements PipeTransform {

  constructor(private _translateService: TranslateService) {
  }

  transform(account: Partial<Account>): string {
    if (account?.type === Role.TradingPlatform) {
      return this._translateService.instant(`register-account.label.${TPTariffsMap.get(account?.tariff)}`);
    }
    return this._translateService.instant(('register-account.label.' + account?.tariff));
  }

}
